import React from 'react';
import classnames from 'classnames';

import styles from '../fieldStyles';

import Chatterbox from 'buyside/components/presentation/Chatterbox/chatterbox';

const PostField = ({
  field,
  form: { dirty, errors, setFieldValue },
  search,
  handleOpenGraphQuery
}) => {
  const bodyLen = field.value ? field.value.replaceAll(/\$\[[^\]]*\]\([^)]*\)/g, '').length : 0;

  return (
    <div>
      <Chatterbox
        onChange={chatterboxValue => {
          setFieldValue(field.name, chatterboxValue);
          handleOpenGraphQuery(chatterboxValue, setFieldValue);
        }}
        search={search}
        placeholder={'Share your insights...'}
        value={field.value}
      />
      <div
        className={classnames(styles.charLimit, {
          [styles.charCountError]: bodyLen > 300
        })}
      >
        {bodyLen} / 300
      </div>
      <div className={styles.fieldNote}>
        {dirty && errors[field.name] && (
          <div className={styles.fieldError}>{errors[field.name]}</div>
        )}
        <strong>To tag a ticker</strong>: start typing "$" followed by a ticker symbol and select it
        from the list that appears.
      </div>
      <br />
    </div>
  );
};

export default PostField;
